import React, { Component } from 'react';
import { Table, Spinner, Card, CardContent, Translate } from '$common';
import capitalize from 'lodash/capitalize';
import InfiniteScroll from 'react-infinite-scroller';

const columns = [
  {
    label: `${Translate.get('report_title')}`,
    content: item => {
      if (item.status === 'completed') {
        return (
          <a
            target="_blank"
            href={item.attachment.url}
            id="live-report-download-button"
            // onClick={ () => window.Intercom('trackEvent', 'DOWNLOADED_REPORT') }
          >
            {item.title}
          </a>
        );
      } else {
        return item.title;
      }
    },
    width: '7/12'
  },
  {
    label: `${Translate.get('status')}`,
    content: item => capitalize(item.status),
    width: '2/12'
  },
  {
    label: `${Translate.get('created_at')}`,
    key: 'created_at',
    type: 'date',
    width: '3/12'
  }
];

export default class Reports extends Component {

  componentWillMount() {
    // window.Intercom('trackEvent', 'OPENED_REPORTS');
  }

  render() {
    const { reports, loadMore, isFetching, hasMore } = this.props;

    return (
      <div>
        <InfiniteScroll
          loadMore={loadMore}
          hasMore={hasMore && !isFetching}
        >
          <Card>
            <CardContent>
              <Table
                columns={columns}
                data={reports}
              />
              {isFetching ? (
                <Spinner block center />
              ) : null}
            </CardContent>
          </Card>
        </InfiniteScroll>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/account/reports.js